import * as React from "react";
import {GatsbyImage} from "gatsby-plugin-image";
import {Link, Trans, useI18next} from "gatsby-plugin-react-i18next";
import * as styles from "../styles/navbar.module.scss";
import {graphql, useStaticQuery} from "gatsby";

const Navbar: React.FC = () => {
	const {language, languages, originalPath} = useI18next();
	const {logo} = useStaticQuery(
		graphql`
			query {
				logo: file(relativePath: {eq: "logo.png"}) {
					childImageSharp {
						gatsbyImageData(layout: FIXED, height: 50)
					}
				}
			}
		`
	);

	return (
		<div className="w-full  bg-white shadow-md">
			<div className="max-w-6xl mx-auto px-4 py-6">
				<div className="flex justify-between">
					<div>
						<Link to="/">
							<GatsbyImage
								alt="Logo"
								image={logo.childImageSharp.gatsbyImageData}
								className="w-40"
							/>
						</Link>
					</div>
					<ul className="flex self-center justify-between">
						<li>
							<Link to="/" className="text-blakish hover:text-blueish transition-all text-base font-semibold px-4">
								<Trans>Home</Trans>
							</Link>
						</li>
						<li>
							<Link to="/posts" className="text-blakish hover:text-blueish transition-all text-base font-semibold px-4">
								<Trans>Posts</Trans>
							</Link>
						</li>
						<li>
							<Link to="/contact-us"
										className="text-blakish hover:text-blueish transition-all text-base font-semibold px-4">
								<Trans>Contact us</Trans>
							</Link>
						</li>
					</ul>
					<ul className={styles.languages}>
						{languages.map((lng) => (
							<li key={lng} className={lng === language ? styles.active : ''}>
								<Link to={originalPath} language={lng}>
									{lng}
								</Link>
							</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	);
};

export default Navbar;
